export const isMechanic = (value: string) => value && value === 'true';
